import { boolean, defineAction, number, object } from '~/prix'
import agentAvailabilityCheckAction from './agentAvailabilityCheck.action.json' assert { type: 'json' }

const agentAvailabilityCheckDefinition = defineAction({
  ...agentAvailabilityCheckAction,
  userActivityLogInput: 'omit' as const,
  operation: 'read' as const,
  input: object({
    latitude: number(),
    longitude: number(),
  }),
  output: object({ available: boolean() }),
})

export default agentAvailabilityCheckDefinition
